import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Tooltip } from "@swiggy-private/core-ui";

export const Container = styled.div<{ isTurboV2?: boolean }>`
    padding: 0;
    width: 100%;
`;

export const BalanceValueContainer = styled.div`
    display: flex;
    :before {
        content: "\u20B9";
        margin-left: 4px;
    }
`;

export const BalanceContentWrapper = styled.div`
    display: flex;
`;

export const OfferText = styled(Text)(({ theme }) => ({
    borderBottom: `1px dashed ${theme.colors.light.positive}`,
    position: "relative",
    display: "inline",
}));

export const StyledTooltip = styled(Tooltip)`
    max-width: 205px;
    height: 100%;
    z-index: 1;
    background-color: ${(props) => props.theme.colors[props.theme.colorMode].background_inverse_Primary};

    &::before {
        background: ${(props) => props.theme.colors[props.theme.colorMode].background_inverse_Primary};
    }

    &:before {
        left: ${(props) => props.theme.spacing.medium};
    }
`;

export const TooltipText = styled(Text)(({ theme }) => ({
    marginTop: `calc(${theme.spacing.xxxSmall} * -1)`,
    flex: 1,
}));

export const TooltipContainer = styled.div`
    position: absolute;
    bottom: 22px;
`;

export const Relative = styled.div`
    position: relative;
    outline: none;
    padding: ${(props) => props.theme.spacing.xxxSmall} 0;
`;
